const ErrorsPage = () => {
  return (
    <>
      <div>ERror</div>
    </>
  );
};

export default ErrorsPage;
